export default "__VITE_ASSET__161708fb__"